import type { GasPayload } from '@atlaskit/analytics-gas-types';

export const FILTER_CHANGE_LOCATION = {
	DROPDOWN: 'dropdown',
	INLINE: 'inline',
	DROPDOWN_FPS: 'dropdown-search-page',
	INLINE_FPS: 'inline-search-page',
	INLINE_FPS_SUGGESTION: 'inline-search-page-suggestion',
} as const;

export type FilterChangeLocation =
	(typeof FILTER_CHANGE_LOCATION)[keyof typeof FILTER_CHANGE_LOCATION];

export type FilterActionSubjectId = 'searchDialogFilter' | 'searchPageFilter';

export const onFilterSelection = ({
	attributes,
	action,
	location,
	actionSubjectId,
}: {
	attributes: Record<string, unknown>;
	action: 'selected' | 'unselected';
	location: FilterChangeLocation;
	actionSubjectId: FilterActionSubjectId;
}): GasPayload => ({
	eventType: 'ui',
	action,
	actionSubject: 'filter',
	actionSubjectId,
	attributes: {
		...attributes,
		location,
	},
});

export const onFilterDropdown = ({
	attributes,
	action,
	actionSubjectId,
}: {
	attributes: Record<string, unknown>;
	action: 'open' | 'close';
	actionSubjectId: 'searchDialogDropdown' | 'searchPageDropdown';
}): GasPayload => ({
	eventType: 'ui',
	action,
	actionSubject: 'filterDropdown',
	actionSubjectId,
	attributes,
});

export const onFilterClear = ({
	attributes,
	location,
	actionSubjectId,
}: {
	attributes: Record<string, unknown>;
	location: FilterChangeLocation;
	actionSubjectId: FilterActionSubjectId;
}): GasPayload => ({
	eventType: 'ui',
	action: 'clear',
	actionSubject: 'filter',
	actionSubjectId,
	attributes: {
		...attributes,
		location,
	},
});

export const onSingleFilterClear = ({
	attributes,
	location,
	actionSubjectId,
}: {
	attributes: Record<string, unknown>;
	location: string;
	actionSubjectId: FilterActionSubjectId;
}): GasPayload => ({
	eventType: 'ui',
	action: 'clear',
	actionSubject: 'filter',
	actionSubjectId,
	attributes: {
		...attributes,
		location,
	},
});
